/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Sourcecodeintro2Inputs */

const id_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua kode sumber untuk egdata.app tersedia di`)
};

const ms_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua kod sumber untuk egdata.app tersedia di`)
};

const da_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al kildekoden til egdata.app er tilgængelig på`)
};

const de_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der gesamte Quellcode von egdata.app ist verfügbar auf`)
};

const en_us2_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All the source code for egdata.app is available on`)
};

const es_es2_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo el código fuente de egdata.app está disponible en`)
};

const es_mx2_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo el código fuente de egdata.app está disponible en`)
};

const fil_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang lahat ng source code para sa egdata.app ay available sa`)
};

const fr_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout le code source d'egdata.app est disponible sur`)
};

const it_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto il codice sorgente di egdata.app è disponibile su`)
};

const hu_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az egdata.app teljes forráskódja elérhető a`)
};

const nl_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle broncode voor egdata.app is beschikbaar op`)
};

const no_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All kildekoden for egdata.app er tilgjengelig på`)
};

const pl_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cały kod źródłowy egdata.app jest dostępny na`)
};

const pt_br2_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo o código fonte de egdata.app está disponível em`)
};

const pt_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo o código-fonte do egdata.app está disponível no`)
};

const ro_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tot codul sursă pentru egdata.app este disponibil pe`)
};

const fi_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki egdata.appin lähdekoodi on saatavilla`)
};

const sv_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All källkod för egdata.app finns tillgänglig på`)
};

const vi_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn bộ mã nguồn của egdata.app có sẵn trên`)
};

const tr_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app için tüm kaynak kodu şurada mevcuttur:`)
};

const cs_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veškerý zdrojový kód egdata.app je k dispozici na`)
};

const bg_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целият изходен код на egdata.app е достъпен на`)
};

const ru_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Весь исходный код egdata.app доступен на`)
};

const uk_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Весь вихідний код egdata.app доступний на`)
};

const ar_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع كود مصدر egdata.app متاح على`)
};

const hi_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app का सभी स्रोत कोड उपलब्ध है`)
};

const th_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซอร์สโค้ดทั้งหมดของ egdata.app พร้อมใช้งานบน`)
};

const ja_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app のすべてのソースコードは以下で入手可能です：`)
};

const zh_cn2_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app 的所有源代码均可在以下位置找到：`)
};

const zh_hant1_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app 的所有原始碼均可在以下位置找到：`)
};

const ko_privacy_sourcecodeintro2 = /** @type {(inputs: Privacy_Sourcecodeintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app의 모든 소스 코드는 다음에서 확인할 수 있습니다`)
};

/**
* | output |
* | --- |
* | "All the source code for egdata.app is available on" |
*
* @param {Privacy_Sourcecodeintro2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_sourcecodeintro2 = /** @type {((inputs?: Privacy_Sourcecodeintro2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Sourcecodeintro2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_sourcecodeintro2(inputs)
	if (locale === "ms") return ms_privacy_sourcecodeintro2(inputs)
	if (locale === "da") return da_privacy_sourcecodeintro2(inputs)
	if (locale === "de") return de_privacy_sourcecodeintro2(inputs)
	if (locale === "en-US") return en_us2_privacy_sourcecodeintro2(inputs)
	if (locale === "es-ES") return es_es2_privacy_sourcecodeintro2(inputs)
	if (locale === "es-MX") return es_mx2_privacy_sourcecodeintro2(inputs)
	if (locale === "fil") return fil_privacy_sourcecodeintro2(inputs)
	if (locale === "fr") return fr_privacy_sourcecodeintro2(inputs)
	if (locale === "it") return it_privacy_sourcecodeintro2(inputs)
	if (locale === "hu") return hu_privacy_sourcecodeintro2(inputs)
	if (locale === "nl") return nl_privacy_sourcecodeintro2(inputs)
	if (locale === "no") return no_privacy_sourcecodeintro2(inputs)
	if (locale === "pl") return pl_privacy_sourcecodeintro2(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_sourcecodeintro2(inputs)
	if (locale === "pt") return pt_privacy_sourcecodeintro2(inputs)
	if (locale === "ro") return ro_privacy_sourcecodeintro2(inputs)
	if (locale === "fi") return fi_privacy_sourcecodeintro2(inputs)
	if (locale === "sv") return sv_privacy_sourcecodeintro2(inputs)
	if (locale === "vi") return vi_privacy_sourcecodeintro2(inputs)
	if (locale === "tr") return tr_privacy_sourcecodeintro2(inputs)
	if (locale === "cs") return cs_privacy_sourcecodeintro2(inputs)
	if (locale === "bg") return bg_privacy_sourcecodeintro2(inputs)
	if (locale === "ru") return ru_privacy_sourcecodeintro2(inputs)
	if (locale === "uk") return uk_privacy_sourcecodeintro2(inputs)
	if (locale === "ar") return ar_privacy_sourcecodeintro2(inputs)
	if (locale === "hi") return hi_privacy_sourcecodeintro2(inputs)
	if (locale === "th") return th_privacy_sourcecodeintro2(inputs)
	if (locale === "ja") return ja_privacy_sourcecodeintro2(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_sourcecodeintro2(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_sourcecodeintro2(inputs)
	return ko_privacy_sourcecodeintro2(inputs)
});
export { privacy_sourcecodeintro2 as "privacy.sourceCodeIntro" }